import PromptInput from "common/widgets/PromptList/PromptInput";
import DFDatePicker from "app/widgets/DFDatePicker/DFDatePicker";
const DatePromptInput = PromptInput.extend({
    options: {
        name: "DatePromptInput"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this.widget = new DFDatePicker(this.input, {});
        this.element.parent()
            .addClass("dateControl")
            .addClass("flexLayout");

        this.widget.bind("change", this.handleChange);
        this.refresh();

        //The initial value for the input might be in an odd format
        //This will ensure that it is transformed into the standard timestamp
        this.options.model.value = this.value();
        this.trigger("valueParse");

        if (options.validateOnBlur) {
            this._onBlur = $.proxy(this._onBlur, this);
            this.bind("blur", this._onBlur);
        }
    },

    readonly: function(readonly) {
        if (readonly) {
            this.input.attr("tabindex", "-1");
        } else {
            this.input.removeAttr("tabindex");
        }
        return PromptInput.fn.readonly.apply(this, arguments);
    },

    /**
     * Override
     */
    destroy: function() {
        // this just reverses the order of the main promptinput.destroy method, so we clean up the widget first.
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
            if (this.options.validateOnBlur) {
                this.unbind("blur", this._onBlur);
            }
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    _onBlur: function() {
        // on blur, we have to detect whether we have a valid date.  If not, we need to set a transient
        // field on the model with the rawValue from the input, so validation has something to use.
        var raw;
        if (!this.options.model.get("value") && this.input.val()) {
            raw = this.input.val();
        }
        this.options.model.set("rawValue", raw);
    },

    /**
     * Override
     */
    setCorrectedSize: function() {
        PromptInput.fn.setCorrectedSize.apply(this, arguments);
        // always set width since this control no longer accepts variable width via user resize
        var labelWidth = this.label.outerWidth();
        var inputWidth = this.element.width();
        var width = labelWidth + inputWidth;
        if (this.options.model.labelPosition === "TOP" || this.options.model.labelPosition === "BOTTOM") {
            width = Math.max(labelWidth, inputWidth);
        }
        this.options.width = width;
    },

    /**
     * Override
     */
    commitValue() {
        this.widget._blur();
    },

    /**
     * Override
     * Don't clear the widget value when an invalid date is input manually
     */
    updateWidgetValue(value) {
        if(value) {
            PromptInput.fn.updateWidgetValue.apply(this, arguments);
        }
    }
});
kendo.ui.plugin(DatePromptInput);
export default DatePromptInput;
